import { Capacitor } from '@capacitor/core';
import { Keyboard } from '@capacitor/keyboard';
import React, { createContext, useContext, useEffect, useState } from 'react';

interface KeyboardContextType {
  isKeyboardOpen: boolean;
}

const KeyboardContext = createContext<KeyboardContextType>({ isKeyboardOpen: false });

export const KeyboardProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const keyboardShowListener = Keyboard.addListener('keyboardWillShow', () => {
      setIsKeyboardOpen(true);
    });

    const keyboardHideListener = Keyboard.addListener('keyboardWillHide', () => {
      setIsKeyboardOpen(false);
    });

    return () => {
      keyboardShowListener.then((listener) => listener.remove());
      keyboardHideListener.then((listener) => listener.remove());
    };
  }, []);

  return <KeyboardContext.Provider value={{ isKeyboardOpen }}>{children}</KeyboardContext.Provider>;
};

export const useKeyboardState = () => {
  const context = useContext(KeyboardContext);
  if (context === undefined) {
    throw new Error('useKeyboardState must be used within a KeyboardProvider');
  }
  return context;
};
